import { Horse_show } from './horse_show';
import { Horse_show_entry } from './horse_show_entry';
import { Sms_order } from './sms_order';
import { Braintree_transaction } from './accounting/banking/braintree_transaction';
import { Entry_processing_fee } from './accounting/entry_processing_fee';
import { User } from './user';

export class Submitted_entries_receipt {
	confirmation_code: string;
	order_id: string;
	order_map: Sms_order[];
	horse_show: Horse_show;
	transactions: Braintree_transaction[];
	horse_show_entry_list: Horse_show_entry[];
	entry_processing_fees: Entry_processing_fee[];
	user: User;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}